import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getAppProps } from '@pages/_app';
import { buildDataUrl } from '@helper/api';
import TemplateDefault from '../../templates/default/default';

import { tokenLogin } from '../../../redux/actions/token';

import Stage from '../../organisms/stage/stage';
import ContentBlocks from '../../organisms/content-blocks/contentBlocks.withRedux';
import ExhibitionContainer from '../../organisms/exhibition-container/exhibitionContainer.withRedux';
import Pagination from '../../organisms/pagination/pagination';
import FloorPlan from '../../organisms/floor-plan/floorPlan';

const Token = ({ meta, tokenId, currentTokenId, updateLogin, floorPlanDataUrl }) => {
  // Check if is already logged in, else set token id
  useEffect(() => {
    if (currentTokenId !== tokenId) {
      updateLogin(true, tokenId);
    }
  }, []);

  return (
    <TemplateDefault>
      <Stage />
      <ContentBlocks noShareLinks />
      <ExhibitionContainer
        hidePaginationArrow={meta && meta.pagination && meta.pagination.total_pages < 2}
      />
      <FloorPlan dataUrl={floorPlanDataUrl} />

      {meta && meta.pagination && meta.pagination.total_pages > 1 && (
        <Pagination
          pageType="token"
          totalPages={parseInt(meta.pagination.total_pages, 10)}
          currentPage={parseInt(meta.pagination.current_page, 10)}
          tokenId={tokenId}
        />
      )}
    </TemplateDefault>
  );
};

Token.propTypes = {
  updateLogin: PropTypes.func.isRequired,
  tokenId: PropTypes.string.isRequired,
  currentTokenId: PropTypes.string.isRequired,
  meta: PropTypes.shape({
    pagination: PropTypes.shape()
  }),
  floorPlanDataUrl: PropTypes.string.isRequired
};

const mapDispatchToProps = dispatch => ({
  updateLogin: (loggedIn, tokenId) => {
    dispatch(tokenLogin(loggedIn, tokenId));
  }
});

const mapStateToProps = ({ token }) => ({
  loggedIn: token.loggedIn,
  currentTokenId: token.id
});

const getTokenProps = async ({ locale, tokenId, page }) => {
  const getPageProps = fetch(
    buildDataUrl(
      `${locale}/${process.env.NEXT_PUBLIC_JSON_API_PATH}/meine-ausstellung/${tokenId}`,
      `?page=${page || 1}`
    )
  )
    .then(res => res.json())
    .catch(err => console.error('[uri]/[uri2]/index.jsx ', err));

  const floorPlanDataUrl = buildDataUrl(`${locale}/${process.env.NEXT_PUBLIC_JSON_API_PATH}/floorplans`);

  const [appProps, data] = await Promise.allSettled([getAppProps({ locale }), getPageProps]).then(
    results => results.map(result => result.value)
  );

  return {
    PAGE_TYPE: 'TOKEN',
    ...appProps,
    ...data,
    floorPlanDataUrl
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Token);
export { getTokenProps };
